import type { ReportsRequestDTO } from './advertiser'

export enum AdType {
  Ads = 'ads',
  Shopping = 'shopping',
}

interface PriceInfoDto {
  originalText: string
  price?: number
  currency?: string
}

interface FeedProviderInfoDto {
  originalText: string
  value: string
}

interface ShippingFeeDto {
  originalText: string
  price?: number
  currency?: string
}

interface MerchantRatingCountDto {
  originalText: string
  value?: number
}

interface MerchantRatingValueDto {
  originalText: string
  value?: number
}

interface MerchantRatingDto {
  count: MerchantRatingCountDto
  rating: MerchantRatingValueDto
}

export interface AdvertisementDTO {
  title: string
  description: string
  displayUrl: string
  targetUrl: string
  engine: string
  language: string
  device: string
  domain: string | null
  type: AdType
  views: number
  firstSeen: string
  lastSeen: string
  positionAvg: number
  aclkURLs: string[]
  keywords: string[]
  image: string
  resultID: string
  priceInfo: PriceInfoDto | null
  originalPriceInfo: PriceInfoDto | null
  shippingFees: ShippingFeeDto | null
  feedProvider: FeedProviderInfoDto | null
  merchantRating: MerchantRatingDto | null
}

interface AdvertisementListMeta {
  page: {
    size: number
    total: number
  }
  request: ReportsRequestDTO
}

interface AdvertisementListLinks {
  next?: string
  prev?: string
  exportCSV?: string
}

export interface AdvertisementListDTO {
  data: AdvertisementDTO[]
  meta: AdvertisementListMeta
  links: AdvertisementListLinks
}

export interface CountAdvertisementDTO {
  countAdvertisement: number
  countShopping: number
}

export interface ActionAdvertisementDTO {
  ID: string
  title: string
  description: string
  displayUrl: string
  targetUrl: string
  aclkUrls: string[]
  engine: string
  country: string
  language: string
  device: string
  domain: string | null
  type: AdType
  image: string
  resultId: string
  realPositionAvg: number
  positionAvg: number
  views: number
  advertisementFirstSeen: string
  advertisementLastSeen: string
  keywords: string[]
}
